import axios from 'axios';

import { ToastService } from '../AppToast';

import { LoadingService } from '../AppLoading';

import { baseURL } from '../config';
import { AppStorage } from './UserStorage';
import { translateError } from '../shared/language';

const _axios = axios.create({
  baseURL,
  xsrfHeaderName: 'RequestVerificationToken',
});

_axios.interceptors.request.use(function (config) {
  if (config['iamUseLoading'] !== false && !config.url.includes('price-html')) {
    LoadingService.start();
  }
  config.headers['Authorization'] = `Bearer ${AppStorage.get('access_token')}`;
  config.headers['__tenant'] = `${AppStorage.get('__tenant')}`;

  return config;
}, function (error) {
  return Promise.reject(error);
});
_axios.interceptors.response.use((response) => {
  LoadingService.stop();
  return response;
}, (error) => {
  LoadingService.stop();
  if (error && error.response && [302, 401].includes(error.response.status)) {
    window.location.hash = '/login';
  } else if (error.response) {
    showError(error.response);
  }
  return Promise.reject(error);
});

const showError = (response) => {
  if (response) {
    ToastService.error(translateError(response));
  }
}

export default _axios;
